<template>
    <div id="comBasicDetailBox">
        <h2></h2>     
        <div class="listItem">
            <el-table ref="multipleTable" :data="profileList" :show-header="false" :cell-style="{padding: '3px', height: '35px'}" :header-cell-style="{ background: 'transparent'}" style="width: 100%;overflow-y:auto;"  empty-text="暫無數據">
                <el-table-column label="標題" prop="title" min-width="35%"> </el-table-column>
                <el-table-column label="內容" prop="value" min-width="65%" ></el-table-column>
            </el-table>
        </div>
        <div class="buttonBox">            
            <el-button type="danger"  @click="closeWin()" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>
        </div>        
    </div>
</template>

<script>
import Pagination from '../components/Pagination.vue';

export default {
    components: {Pagination},
    data() {
        return {
            profileList:[],
            qry : {
                "DataDt": this.$route.query.dataDt,
                "SearchContent" : [this.$route.query.comName],
                "Page_Size":10,
                "Page_Num":1
            }
        }        
    },
    methods: {
        getList() {
            this.$store.dispatch("loadingHandler", true);
            this.$api.apimgrs.searchMopsBaseInfo(this.qry).then(res => {
                console.log("data",res.data);
                if( res.data.length > 0 ) {
                    var ret = res.data[0];
                    this.profileList.push({title:"證券代號", value: ret.StockCode });
                    this.profileList.push({title:"公司名稱", value: ret.ComName });
                    this.profileList.push({title:"公司簡稱", value: ret.ComAbbr });
                    this.profileList.push({title:"市場類別", value: ret.ComType });
                    this.profileList.push({title:"產業類別", value: ret.IndusType });
                    this.profileList.push({title:"外國企業註冊國家", value: ret.ForeignRegCountry });
                    this.profileList.push({title:"公司地址", value: ret.ComAdd });
                    this.profileList.push({title:"營利事業統一編號", value: ret.UniComNm });
                    this.profileList.push({title:"董事長", value: ret.Chairman });
                    this.profileList.push({title:"總經理", value: ret.GeneralManager });
                    this.profileList.push({title:"發言人", value: ret.Spokesman });
                    this.profileList.push({title:"發言人職稱", value: ret.SpokesTitle });
                    this.profileList.push({title:"代理發言人", value: ret.ActSpokesman });
                    this.profileList.push({title:"總機電話", value: ret.MainPhone });
                    this.profileList.push({title:"成立日期", value: ret.ApvDt });
                    this.profileList.push({title:"上市日期", value: ret.ListDt });
                    this.profileList.push({title:"普通股每股面額", value: ret.PerStockAmount });
                    this.profileList.push({title:"實收資本額(元)", value: this.millionStr(ret.PUCap) });
                    this.profileList.push({title:"已發行普通股數或TDR原發行股數", value: this.millionStr(ret.PubStock) });
                    this.profileList.push({title:"私募普通股(股)", value: this.millionStr(ret.PvtStock) });
                    this.profileList.push({title:"特別股(股)", value: this.millionStr(ret.SpecStock) });              
                }
                    
                else
                    this.profileList = [];
                var ret = res.data[0];                
            });
            this.$store.dispatch("loadingHandler", false);
        },
        closeWin() {
            window.close();
        },   
        millionStr(intPart) {
            let newPart = Math.trunc(intPart);
            return newPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');            
        },                  
    },
    async mounted() {
        this.$store.dispatch("loadingHandler", true);
        console.log("ComName",this.qry);
        this.getList();
        this.$store.dispatch("loadingHandler", false);
    }    
}
</script>

<style lang="scss" scoped>
#comBasicDetailBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;

  .listItem   {
    padding: 0 5%;
  }

  .buttonBox {
    padding: 0 5%;
    display: flex;
    justify-content: center;

  }
}
</style>